module.exports = __webpack_public_path__ + "img/blueprint-original.b4ba5383.jpg";